<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<div class="mgb_5">
					<partner-select v-model="param.ship_to_code" ph="Ship To" />
					<em class="lt_text">Invoice Date</em>
					<span class="mgr_5">
						<CustomDatePicker v-model="param.fromDate" /> ~
						<CustomDatePicker v-model="param.toDate" />
					</span>
				</div>
				<div class="mgb_5">
					<item-class-select-multi-s v-model="param.classList" />
				</div>
				<div class="mgb_5">
					<item-class-group v-model="param.classGroup" ref="classGroup" />
					<item-department-a v-model="param.deptA" ref="deptA" />
					<item-department-b v-model="param.deptB" ref="deptB" class="mgr_10" />

					<label>
						<input type="checkbox" v-model="param.group_by_sg" />
						<span>Partition by SG</span>
					</label>
				</div>
				<div class="mgb_5">
					<sales-group v-model="param.salesGroupCode" ref="salesGroupCode" />
					<CountrySelect v-model="param.country" :bool="bool" ref="country" />
					<state-select v-model="param.state" :country="param.country" ref="state" />
					<label>
						<em class="lt_text">Record</em>
						<span class="int_type_no_border mgr_5">
							<currency-input type="text" v-model="param.record" :precision="0" class="tbl_int ssm_int al_right" />
						</span>
					</label>
					<label>
						<em class="lt_text">Order By</em>
						<span class="mgr_5">
							<select class="int_type" v-model="param.orderType">
								<option value="B">Sales Qty</option>
								<option value="A">Sales Amount</option>
							</select>
						</span>
					</label>
					<label>
						<em class="lt_text">Sort</em>
						<span class="mgr_5">
							<select class="int_type" v-model="param.sort">
								<option value="D">DESC</option>
								<option value="A">ASC</option>
							</select>
						</span>
					</label>
					<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
					<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>
				</div>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<CommonTable :tbl_headers="tbl_headers" :data="root" />
			</div>
		</div>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="print">Print</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { objectToFormData, reportMrtUrl, reportRenderHorizontally } from '@/api/util';
import { apiSalesTopRecordClass } from '@/api/report/report';
import { today } from '@/utils/date';
import { defaultDataType } from 'export-xlsx';
import { exportDataExcel } from '@/api/util';

import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import ItemDepartmentB from '@/components/common/ItemDepartmentB';
import ItemDepartmentA from '@/components/common/ItemDepartmentA';
import ItemClassGroup from '@/components/common/ItemClassGroup';
import SalesGroup from '@/components/common/SalesGroup';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CountrySelect from '@/components/common/CountrySelect';
import StateSelect from '@/components/common/StateSelect';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import PartnerSelect from '@/components/common/PartnerSelect';

export default {
	props: ['headers'],
	data: function() {
		return {
			param: {
				classGroup: '',
				deptA: '',
				deptB: '',
				salesGroupCode: '',
				fromDate: today(),
				toDate: today(),
				country: '',
				state: '',
				orderType: 'B',
				sort: 'D',
				record: 100,
				classList: [],
				ship_to_code: '',
				group_by_sg: false,
			},
			root: [],
			tbl_headers: [],
		};
	},
	components: {
		CommonTable,
		PartnerSelect,
		ItemDepartmentA,
		ItemDepartmentB,
		ItemClassGroup,
		SalesGroup,
		CustomDatePicker,
		CountrySelect,
		StateSelect,
		ItemClassSelectMultiS,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user && this.user.company_id ? this.user.company_id : '';
		},
		bool() {
			return ['newjigu'].includes(this.company_id);
		},
		isBpNHp() {
			return ['beautyplus', 'hairplus'].includes(this.company_id);
		},
	},
	methods: {
		reset() {
			this.$refs.classGroup.reset();
			this.$refs.salesGroupCode.reset();
			this.$refs.deptA.reset();
			this.$refs.deptB.reset();
			this.$refs.country.reset();
			this.$refs.state.reset();
			this.param.fromDate = today();
			this.param.toDate = today();
			this.param.record = 100;
			this.param.orderType = 'B';
			this.param.sort = 'D';
			this.param.classList = [];
			this.param.group_by_sg = false;
		},
		print() {
			reportRenderHorizontally(this.root, 'SalesTopRecordClass', reportMrtUrl('SalesTopRecordClass'));
		},
		async search() {
			// 헤더 설정
			this.setHeader();
			if (this.param.group_by_sg) this.addSGHeader();

			const param = objectToFormData(this.param);
			const { data } = await apiSalesTopRecordClass(param);
			this.root = this.makeDisplayData(data);
		},
		makeDisplayData(data) {
			if (Array.isArray(data)) {
				data.forEach((el, index) => {
					if (this.param.group_by_sg) {
						el.rank = el.ranking;
						if (!el.ranking) el.tr_class = 'bg_gray';
					} else {
						el.rank = index + 1;
					}

					if (index > 0 && el.groupCode === data[index - 1].groupCode) {
						el.cell_style = { groupCode: 'child_dp_none', groupName: 'child_dp_none' };
					}
				});
			} else {
				data = [];
			}

			return data;
		},
		async excel() {
			exportDataExcel(this.root, this.tbl_headers, 'SalesTopRecordClass');
		},

		defaultHeader() {
			return [
				{ key: 'rank', name: 'Rank', width: 10, dataType: defaultDataType.currency, tbl_width: '3%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'groupCode', name: 'Group', width: 15, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'groupName', name: 'Group Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left' },
				{ key: 'classCode', name: 'Class', width: 15, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_left' },
				{ key: 'className', name: 'Class Name', width: 30, dataType: defaultDataType.string, td_class: 'al_left' },
				{ key: 'salesQty', name: 'Sales Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '7%', td_class: 'al_right', display_filter: 'commaSeparated' },
				{ key: 'salesAmount', name: 'Sales Amount', width: 15, dataType: defaultDataType.number, tbl_width: '10%', td_class: 'al_right', display_filter: 'toCurrency' },
			];
		},
		bpNHpHeader() {
			const header = this.defaultHeader();
			const added_header = [
				{ key: 'rack', name: 'Rack', width: 10, dataType: defaultDataType.string, tbl_width: '5%', td_class: 'al_center' },
				{ key: 'section', name: 'Section', width: 10, dataType: defaultDataType.string, tbl_width: '5%', td_class: 'al_center' },
			];

			let idx = header.findIndex(h => h.key === 'salesQty'); // 추가할 위치
			if (idx < 0) idx = header.length;
			header.splice(idx, 0, ...added_header);

			return header;
		},
		addSGHeader() {
			const added_header = [
				{ key: 'salesGroupCode', name: 'SG Code', width: 10, dataType: defaultDataType.string, tbl_width: '5%', td_class: 'al_center' },
				{ key: 'salesGroupName', name: 'SG Name', width: 15, dataType: defaultDataType.string, tbl_width: '10%', td_class: 'al_center' },
			];
			this.tbl_headers.splice(0, 0, ...added_header);
		},
		setHeader() {
			this.tbl_headers = this.isBpNHp ? this.bpNHpHeader() : this.defaultHeader();
		},
	},

	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_salesTopRecordClass');
		this.$store.commit('setSubTitle', `Report -> Sales Top Record ${this.headers.class}`);

		this.setHeader();
	},
	mounted() {},
};
</script>

<style></style>
